import prepareOptions from '../../prepareOptions';

import {
  DRIVER,
  FRONT,
  FRONT_AND_SIDE,
  FRONT_AND_SIDE_AND_MORE,
} from './values';

export default prepareOptions([
  {
    value: DRIVER,
    label: __('carDetails.equipmentGroups.driverAirbag'),
  },
  {
    value: FRONT,
    label: __('carDetails.equipmentGroups.frontAirbag'),
  },
  {
    value: FRONT_AND_SIDE,
    label: __('carDetails.equipmentGroups.frontAndSideAirbags'),
  },
  {
    value: FRONT_AND_SIDE_AND_MORE,
    label: __('carDetails.equipmentGroups.frontSideAndMoreAirbags'),
  },
]);
